import { useQuery } from "@tanstack/react-query";
import { extractPaginatedCollection } from "../../utils/apiResponse";

async function getDatasets({
  callApiWithWorker,
  language,
  pageIndex,
  pageSize,
  signal,
}) {
  const url =
    `/datasets?language=${encodeURIComponent(language)}` +
    `&page=${pageIndex}&size=${pageSize}`;

  const res = await callApiWithWorker(url, { method: "GET", signal });
  return extractPaginatedCollection(res);
}

export function useGetDatasets({
  callApiWithWorker,
  language,
  pageIndex,
  pageSize,
}) {
  return useQuery({
    queryKey: ["datasets", language, pageIndex, pageSize],
    queryFn: ({ signal }) =>
      getDatasets({
        callApiWithWorker,
        language,
        pageIndex,
        pageSize,
        signal,
      }),
    enabled:
      Boolean(callApiWithWorker) &&
      Boolean(language) &&
      Number.isInteger(pageIndex) &&
      Number.isInteger(pageSize),
    staleTime: 60_000,
    gcTime: 5 * 60_000,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });
}
